import { HistoryMessageType } from '@shared/modules/history-message/classes/HistoryMessageType';

export function getPaginatedParams(page: number, perPage: number, type?: HistoryMessageType) {
  const params = { page: page.toString(), perPage: perPage.toString() };

  return type ? { ...params, type } : params;
}
